import { Fragment } from 'react';

import { LegalDisclaimer } from '@playbooks/components/auth/legal-disclaimer';
import { GithubAuthBtn } from '@playbooks/components/github/github-auth-btn';
import { GoogleAuthBtn } from '@playbooks/components/google/google-auth-btn';
import { Feedback } from '@playbooks/molecules/feedbacks';
import { Button } from '@playbooks/ui/components/button';
import { DialogFooter, DialogHeader, DialogTitle } from '@playbooks/ui/components/dialog';
import { Separator } from '@playbooks/ui/components/separator';

import { useSession } from 'contexts';

const ReferralFlowWelcome = ({ model, referralCode, onClose, onView, onNext }) => {
	const session = useSession();

	// Render
	return (
		<Fragment>
			<DialogHeader>
				<DialogTitle>Welcome</DialogTitle>
			</DialogHeader>
			<div>
				{session.isAuthenticated() && model.id ? (
					<Feedback
						layout='section'
						icon='hand-wave'
						title={`${model.name} invited you to Playbooks`}
						text={`Would you like to use their referral code to get $20 off your subscription? We'll automatically apply it to your next paid invoice.`}
						className='w-full'
					/>
				) : model.id ? (
					<Feedback
						layout='section'
						icon='hand-wave'
						title={`${model.name} invited you to Playbooks`}
						text={`We're building a platform where you can find inspiration, collaborate, and earn cash sharing code with your peers. Join today and let's build a new developer economy together.`}
						className='w-full'
					/>
				) : (
					<Feedback
						layout='section'
						variant='destructive'
						icon='circle-xmark'
						title='Not Found'
						text={`Sorry, we were unable to find an account associated with that referral code. Please try again later.`}
						className='w-full'
					/>
				)}
			</div>
			{session.isAuthenticated() ? (
				<DialogFooter className='block space-y-4'>
					<Button size='default' onClick={() => onView('processing')} className='w-full'>
						Accept Referral
					</Button>
					<Button variant='outline' size='default' onClick={onClose} className='w-full'>
						No, Thanks
					</Button>
				</DialogFooter>
			) : (
				<DialogFooter className='block space-y-4'>
					<GoogleAuthBtn referralCode={referralCode} onNext={onNext} />
					<GithubAuthBtn variant='outline' referralCode={referralCode} onNext={onNext} />
					<div className='flex-middle gap-3 text-xs text-foreground-subtle'>
						<Separator />
						<span>or</span>
						<Separator />
					</div>
					<Button variant='outline' size='lg' onClick={() => onView('login')} className='w-full'>
						Log in with email
					</Button>
					<Button variant='outline' size='lg' onClick={() => onView('register')} className='w-full'>
						Register with email
					</Button>
					<LegalDisclaimer />
				</DialogFooter>
			)}
		</Fragment>
	);
};
export { ReferralFlowWelcome };
